import { workerFactory } from "@modules/app";
import { TrainingOrchestratorModule } from "@modules/training";
export class TrainingUserMistakeService {
    constructor() {
        this.sequencesWithOccurredErrors = [];
        this.alreadyFinishedSequences = [];
        this.newSequencesWithMistakes = [];
        this.stageErrors = [];
        this.isRevisitErrorMode = false;
    }
    addStageError(stage, text, errorType) {
        this.stageErrors.push({ stage, text, errorType });
        this.addSequencesForStage(stage);
    }
    addStageViolation(stage) {
        this.addSequencesForStage(stage);
    }
    getStageLabel(stageId) {
        var _a, _b;
        if (stageId === undefined)
            return "Unbekannte Stage";
        const module = workerFactory.getModule(TrainingOrchestratorModule);
        const scenario = module === null || module === void 0 ? void 0 : module.getScenario();
        return (_b = (_a = scenario === null || scenario === void 0 ? void 0 : scenario.stages.find(stage => stage.id === stageId)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : stageId;
    }
    addSequencesForStage(stage) {
        var _a;
        const module = workerFactory.getModule(TrainingOrchestratorModule);
        if (module === undefined) {
            console.warn("[scripting] TrainingOrchestratorModule not found");
            return;
        }
        const scenario = module.getScenario();
        (_a = scenario === null || scenario === void 0 ? void 0 : scenario.sequences) === null || _a === void 0 ? void 0 : _a.forEach((sequence) => {
            if (sequence.hasStage(stage.id)) {
                this.addSequenceWithUserMistake(sequence);
            }
        });
    }
    getStageErrors() {
        return [...this.stageErrors];
    }
    getNumberOfNewSequencesWithMistakes() {
        return this.newSequencesWithMistakes.length;
    }
    getNewSequenceIdsWithOccurredErrors() {
        return this.newSequencesWithMistakes.map(s => s.id);
    }
    getNewSequenceNamesWithOccurredErrors() {
        return this.newSequencesWithMistakes.map(s => s.name);
    }
    getNumberOfSequencesWithMistakes() {
        return this.sequencesWithOccurredErrors.length;
    }
    addStage(stageChange) {
        var _a, _b;
        if (stageChange.previousState === undefined)
            return;
        this.addStageError(stageChange.previousState, (_b = (_a = stageChange.nextState) === null || _a === void 0 ? void 0 : _a.errorText) !== null && _b !== void 0 ? _b : "", "Falsches Verhalten");
    }
    addSequenceWithUserMistake(trainingSequence) {
        if (this.newSequencesWithMistakes.includes(trainingSequence))
            return;
        this.newSequencesWithMistakes.push(trainingSequence);
    }
    resetMistakes() {
        this.sequencesWithOccurredErrors = [...this.newSequencesWithMistakes];
        this.newSequencesWithMistakes = [];
        this.alreadyFinishedSequences = [];
        this.currentTrainingSequence = undefined;
    }
    getCurrentTrainingSequence() {
        return this.currentTrainingSequence;
    }
    updateStageWithUserMistake(trainingStage) {
        var _a;
        if ((trainingStage === null || trainingStage === void 0 ? void 0 : trainingStage.isError) === true)
            return false;
        const moveSequenceToAlreadyFinished = () => {
            if (this.currentTrainingSequence !== undefined) {
                this.alreadyFinishedSequences.push(this.currentTrainingSequence);
                this.sequencesWithOccurredErrors = this.sequencesWithOccurredErrors.filter((sequence) => sequence !== this.currentTrainingSequence);
                console.log("[training] !!!", this.alreadyFinishedSequences);
                console.log("[training] !!!", this.sequencesWithOccurredErrors);
            }
        };
        if (((_a = this.currentTrainingSequence) === null || _a === void 0 ? void 0 : _a.hasStage(trainingStage === null || trainingStage === void 0 ? void 0 : trainingStage.id)) === true) {
            // user made mistake in current sequence, but no gap, so just stay in current sequence
            return false;
        }
        else {
            // we left the current sequence
            let foundSequence;
            for (const sequence of this.sequencesWithOccurredErrors) {
                if (sequence.hasStage(trainingStage === null || trainingStage === void 0 ? void 0 : trainingStage.id)) {
                    foundSequence = sequence;
                    break;
                }
            }
            if (foundSequence !== undefined) {
                // found new sequence with the stageid but with no gap, so move to this sequence
                moveSequenceToAlreadyFinished();
                this.currentTrainingSequence = foundSequence;
                return false;
            }
            else {
                // found gap
                moveSequenceToAlreadyFinished();
                if (this.sequencesWithOccurredErrors.length > 0)
                    this.currentTrainingSequence = this.sequencesWithOccurredErrors[0];
                else
                    this.currentTrainingSequence = undefined;
                return true;
            }
        }
    }
}
export const trainingUserMistakeService = new TrainingUserMistakeService();
